// src/components/FloatingContactButton.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

const FloatingContactButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/contact')}
      className="fixed bottom-20 right-4 bg-green-600 text-white p-3 rounded-full shadow-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-300 hover:scale-110 z-50 group"
      aria-label="צור קשר"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="absolute right-full top-1/2 -translate-y-1/2 mr-2 bg-white text-green-600 px-2 py-1 rounded shadow-md text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        צור קשר
      </span>
    </button>
  );
};

export default FloatingContactButton;